import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { postsByCategory } from "./detail.config";
import { DetailedArticle } from "components";

function Detail() {
  const [postInfo, setPostInfo] = useState(null);
  const { slug, category } = useParams();

  useEffect(() => {
    const posts = postsByCategory[category];
    const currentPost = posts.find((item) => item.slug === slug);
    setPostInfo(currentPost);
  }, [slug, category]);

  return postInfo ? (
    <DetailedArticle
      title={postInfo.title}
      author={postInfo.author}
      description={postInfo.description}
      //   handleBack={handleBack}
    />
  ) : null;
}

export default Detail;
